export default {
  /**
   * 判断是否为空对象
   * @param {Object} obj 对象
   */
  isEmptyObj(obj) {
    const len = Object.keys(obj).length;
    return len === 0;
  },
  addZero(num) {
    return num < 10 ? "0" + num : num;
  },
  inArray(item,arr){
    var flag = false
    arr.map(function(value){
      if (item == value) {
        flag = true;
      }
    });
    return flag;
  },
  send_log(){
    console.log('send_log');
  },
  /**
   * 倒计时函数
   * @param {Date} time 结束时间
   * @returns {Function} 处理程序
   * @example
      import util from "@/util/index";
      const endTime =new Date().setDate(new Date().getDate() + 1)
      const countDown = util.countDown(endTime);
      countDown({
        onCountDownIng(parse,surplus){
          console.log(parse,surplus)//23:59:58
        }
      })

   */
  countDown(time) {
    const endTime = new Date(time).getTime();
    let timer = null;
    let handle = () => {
      let now = Date.now(),
        surplus = parseInt((endTime - now) / 1000),
        s = surplus % 60,
        min = parseInt((surplus / 60) % 60),
        hour = parseInt((surplus / 60 / 60) % 24),
        day = parseInt(surplus / 60 / 60 / 24);
      return {
        parse:this.addZero(hour) + ":" + this.addZero(min) + ":" + this.addZero(s), //格式化的时间
        surplus//剩余时间戳
      };
    };
    /**
     * onCountDownIng  正在倒计时
     * onCountEnded    倒计时结束
     */
    return ({ onCountDownIng, onCountEnded }) => {
      timer = setInterval(() => {
        let surplus = handle();
        if (surplus.surplus <= 0) {
          clearInterval(timer);
          onCountEnded && onCountEnded(surplus.parse,surplus.surplus);
        } else {
          onCountDownIng && onCountDownIng(surplus.parse,surplus.surplus);
        }
      }, 1000);
    };
	},
	/**
	 * 合并对象
	 * @param {Object} target 目标
	 * @param {Object[]} args 对象
	 */
	merge(target,...args){
		args.forEach(obj=>{
		
			Object.keys(obj).forEach(key=>{
				let value = obj[key];
			
					if(value!=undefined){
						target[key]=value;
					}
				
			})
		})
		return target;
	},

	hasClass(el, cls) {
		let clses = el.className;
		let reg = new RegExp(`^(\\b${cls})|(\\b${cls}\\b)|(${cls}\\b)`, "g");
		return reg.test(clses);
	},
	addClass(el, cls) {
		if (!this.hasClass(el, cls)) {
			el.className += " " + cls;
		}
	},
	removeClass(el, cls) {
		const reg =new RegExp(cls, "g");
		if (this.hasClass(el, cls)) {
			el.className.replace(reg, "");
		}
	},
	setTitle(name){
		document.title=name;
	}
};
